const EARTH_RADIUS_KM = 6371;
const KM_TO_MILES = 0.621371;

const toFiniteNumber = (value: number | string) => {
    const numericValue = Number(value);
    return Number.isFinite(numericValue) ? numericValue : null;
};

const isValidLat = (lat: number) => lat >= -90 && lat <= 90;
const isValidLon = (lon: number) => lon >= -180 && lon <= 180;

export const getDistanceMiles = (
    lat1: number | string,
    lon1: number | string,
    lat2: number | string,
    lon2: number | string,
) => {
    const normalizedLat1 = toFiniteNumber(lat1);
    const normalizedLon1 = toFiniteNumber(lon1);
    const normalizedLat2 = toFiniteNumber(lat2);
    const normalizedLon2 = toFiniteNumber(lon2);

    if (
        normalizedLat1 === null ||
        normalizedLon1 === null ||
        normalizedLat2 === null ||
        normalizedLon2 === null ||
        !isValidLat(normalizedLat1) ||
        !isValidLat(normalizedLat2) ||
        !isValidLon(normalizedLon1) ||
        !isValidLon(normalizedLon2)
    ) {
        return Infinity;
    }

    const lat1Rad = (normalizedLat1 * Math.PI) / 180;
    const lat2Rad = (normalizedLat2 * Math.PI) / 180;
    const dLat = ((normalizedLat2 - normalizedLat1) * Math.PI) / 180;
    const dLon = ((normalizedLon2 - normalizedLon1) * Math.PI) / 180;

    const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(lat1Rad) *
        Math.cos(lat2Rad) *
        Math.sin(dLon / 2) ** 2;

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return EARTH_RADIUS_KM * c * KM_TO_MILES;
};